export default "__VITE_ASSET__a60d022c__"